const deliveryAddress = {
  addTitle: 'Neue Lieferadresse hinzufügen',
  addSubtitle: 'Hier können Sie Ihre Lieferadresse hinzufügen.',
  editTitle: 'Lieferadresse bearbeiten',
  editSubtitle: 'Hier können Sie Ihre Lieferadresse bearbeiten.',
  save: 'Speichern',
  update: 'Aktualisieren',
  back: 'Zurück',
  editSuccess: 'Ihre Lieferadresse wurde erfolgreich geändert',
  addSuccess: 'Ihre neue Lieferadresse wurde erfolgreich gespeichert',
  infoMessage: '{strongText}: Wir nutzen die Telefonnummer nur für eventuelle Rückfragen der Apotheke zu Ihren Vorbestellungen. Außerdem werden Sie per SMS und E-Mail über den Status Ihrer Bestellung informiert.',
  infoMessageTitle: 'Unser Versprechen',
  fillNecessary: '* Bitte füllen Sie die Pflichtfelder aus',
}

export default deliveryAddress
